// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 12101-新增年龄组 POST /web/v1/ageGroup/add */
export async function addAgeGroup(
  body: API.SwimAgeGroupAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/web/v1/ageGroup/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 12102-删除年龄组 GET /web/v1/ageGroup/delete/${param0} */
export async function deleteAgeGroup(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteAgeGroupParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOVoid>(`/web/v1/ageGroup/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 12104-年龄组详情 GET /web/v1/ageGroup/detail/${param0} */
export async function getAgeGroupDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getAgeGroupDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimAgeGroupDetailVo>(
    `/web/v1/ageGroup/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 12105-年龄组列表 POST /web/v1/ageGroup/list */
export async function getAgeGroupList(
  body: API.SwimAgeGroupListQueryVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimAgeGroupListVo>(
    "/web/v1/ageGroup/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 12103-修改年龄组信息 POST /web/v1/ageGroup/update */
export async function updateAgeGroup(
  body: API.SwimAgeGroupUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOVoid>("/web/v1/ageGroup/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
